export const ADD_VENDOR_MODAL_TITLE = "Add New Vendor";
export const SERVICE_LOCATION_TITLE = "Service Location";
